module.exports = __webpack_public_path__ + "img/Procesmonitoring.015dbc61.png";